import { render, staticRenderFns } from "./TagTypeNewPage.vue?vue&type=template&id=4ec9b724"
import script from "./TagTypeNewPage.vue?vue&type=script&lang=ts"
export * from "./TagTypeNewPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports